

import React from 'react';
import MyNavbar from '../../../components/customer/MyNavbar';
import ServicesHero from '../../../screens/customer/services/ServicesHero';
import FeaturesSection from '../../../screens/customer/services/FeaturesSection'; 
import ServicesCardsSection from '../../../screens/customer/services/ServicesCardsSection'; 
import TeamSection from '../../../screens/customer/services/TeamSection';
import GallerySection from '../../../screens/customer/services/GallerySection';
import ActionSection from '../../../screens/customer/services/ActionSection';
import Footer from '../../../components/customer/Footer';

const Services = () => {
  return (
    <>
   <MyNavbar/> 
      <ServicesHero />
      <FeaturesSection />
    {/* <ServicesCardsSection/> */}
       <TeamSection />
        <GallerySection />
        <ActionSection />
       <Footer/>
     
      
      
      
    </>
  );
};

export default Services;